'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../css/Panel.css');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
C={'c1'} 
HeaderIcon={"Settings"}  
Header={Vas.Resources.Labels["Pupil"]} 
Id={"row1"} 
Drag={true/false} 
Content={}

optional:
Width={600} Height={'auto'}
*/

var Panel = function (_Component) {
    _inherits(Panel, _Component);

    function Panel(props) {
        _classCallCheck(this, Panel);

        var _this = _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));

        _this.state = {};
        _this.state.open = true;
        return _this;
    }

    _createClass(Panel, [{
        key: 'dropDown',
        value: function dropDown(c) {
            var _this2 = this;

            var me = this;
            if ((0, _jquery2.default)("#" + c).is(':visible')) {
                /*if (aktivierte container id = visible)*/
                (0, _jquery2.default)("#" + c).hide();
                me.setState({ open: false }, function () {
                    var values = _this2.state.oldValues;
                    if (values) {
                        var id = (0, _jquery2.default)("#" + c).parent().parent()[0].id;
                        for (var i = 0; i < values.length; i++) {
                            if (id === values[i][0]) {
                                values[i][1] = false;
                            }
                        }
                        if (_this2.props.reference !== undefined) {
                            me.props.reference.setState({ newValues: values }, function () {
                                _this2.props.reference.Save();
                            });
                        }
                    }
                });
            } else {
                (0, _jquery2.default)("#" + c).show();
                this.setState({ open: true }, function () {
                    var values = _this2.state.oldValues;
                    if (values) {
                        var id = (0, _jquery2.default)("#" + c).parent().parent()[0].id;
                        for (var i = 0; i < values.length; i++) {
                            if (id === values[i][0]) {
                                values[i][1] = true;
                            }
                        }
                        if (_this2.props.reference !== undefined) {
                            _this2.props.reference.setState({ newValues: values }, function () {
                                _this2.props.reference.Save();
                            });
                        }
                    }
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            //Workaround für die Farbe der Icons bzgl. der anderen Projekte
            //Wenn die Property nicht gefüllt ist, wird Weiß genommen (Standardfarbe)
            //Wenn die Farbe gefüllt ist, wird diese genommen
            var iconClolor = this.props.IconColor == undefined || this.props.IconColor == null ? "white" : this.props.IconColor;

            var headerIcon = "";
            if (this.props.HeaderIcon) {
                headerIcon = _react2.default.createElement(_Icon2.default, {
                    AppURL: this.props.AppURL,
                    Name: this.props.HeaderIcon,
                    Size: 18,
                    Color: iconClolor,
                    Align: "left" });
            }

            var Style = null;

            if (this.props.Width) {
                Style = { width: this.props.Width, float: this.props.Float };
            }

            var right = this.props.Right;
            var content = '';

            if (this.props.Content) {
                content = this.props.Content;
            } else {
                if (right) {
                    var read = '';
                    var create = '';
                    var edit = '';
                    var del = '';

                    if (right.Read === true) {
                        read = this.props.read;
                    }

                    if (right.Create === true) {
                        create = this.props.create;
                    }

                    if (right.Edit === true) {
                        edit = this.props.edit;
                    }

                    if (right.Delete === true) {
                        del = this.props.delete;
                    }

                    content = _react2.default.createElement(
                        'div',
                        null,
                        read,
                        create,
                        edit,
                        del
                    );
                }
            }

            var open = '';
            if (this.state.open === true) {
                open = _react2.default.createElement(
                    'div',
                    {
                        id: this.props.C,
                        className: 'c',
                        style: { display: 'inline' } },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'panelContent',
                            style: { Style: Style, height: this.props.Height } },
                        content
                    )
                );
            } else {
                open = _react2.default.createElement(
                    'div',
                    {
                        id: this.props.C,
                        className: 'c',
                        style: { display: 'none' } },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'panelContent',
                            style: { Style: Style, height: this.props.Height } },
                        content
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    className: "border",
                    draggable: this.props.Drag,
                    id: this.props.Id },
                _react2.default.createElement(
                    'div',
                    {
                        className: "panel",
                        style: Style },
                    _react2.default.createElement(
                        'div',
                        {
                            className: "panelHeader",
                            onClick: function onClick() {
                                _this3.dropDown(_this3.props.C);
                            } },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        headerIcon
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        {
                                            className: 'copen',
                                            'data-c': this.props.C,
                                            style: { display: 'inline' } },
                                        this.props.Header
                                    )
                                )
                            )
                        )
                    ),
                    open
                )
            );
        }
    }]);

    return Panel;
}(_react.Component);

exports.default = Panel;